import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateBabyAgeInMonths(birthDate: string): number {
  const birth = new Date(birthDate);
  const today = new Date();
  const months = (today.getFullYear() - birth.getFullYear()) * 12 + (today.getMonth() - birth.getMonth());
  
  // Adjust if the day hasn't passed yet in the current month
  if (today.getDate() < birth.getDate()) {
    return months - 1;
  }
  
  return Math.max(0, months);
}

export function generatePlaceholderImage(title: string): string {
  // Generate a colorful placeholder image URL based on title
  const colors = ['ff6b6b', '4ecdc4', '45b7d1', 'f9ca24', 'f0932b', 'eb4d4b', '6c5ce7'];
  const colorIndex = title.length % colors.length;
  const color = colors[colorIndex];
  
  return `/placeholder.svg`;
}